import { ReactNode } from 'react';

type CommonDependencyConfig = {
  api: Record<string, (params?: any) => any>;
  components: Record<string, any>;
  richtextEditorConfig?: {
    emojiStyle?: string;
  };
  // common?: Record<string, any>;
  text?: Record<string, ReactNode>;
};

export let CommonDependency: CommonDependencyConfig = {
  api: {},
  components: {},
  text: {},
  // common: {},
  richtextEditorConfig: {},
};

export const setCommonDependency = (config: CommonDependencyConfig) => {
  CommonDependency = {
    ...CommonDependency,
    ...config,
  };
};
